// src/context/EnvironmentContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import apiClient from "../services/EnhancedApiClient";

// Create the context
const EnvironmentContext = createContext();

// Environment provider component
export const EnvironmentProvider = ({ children }) => {
  const [environment, setEnvironment] = useState("production");
  const [isLoading, setIsLoading] = useState(true);
  const [authStatus, setAuthStatus] = useState({
    isAuthenticated: false,
    user: null
  });

  // Function to change environment (moved inside component)
  const changeEnvironment = (newEnv) => {
    setEnvironment(newEnv);
    apiClient.setEnvironment(newEnv);
    
    // Update URL without reload
    const url = new URL(window.location);
    if (newEnv === "staging") {
      url.searchParams.set("env", "staging");
    } else {
      url.searchParams.delete("env");
    }
    window.history.pushState({}, "", url);
    
    return newEnv;
  };

  useEffect(() => {
    // Get environment from URL params on initial load
    const urlParams = new URLSearchParams(window.location.search);
    const envParam = urlParams.get("env");
    
    if (envParam === "staging") {
      setEnvironment("staging");
      apiClient.setEnvironment("staging");
    } else {
      setEnvironment("production");
      apiClient.setEnvironment("production");
    }
    
    setIsLoading(false);
  }, []);

  // Auth status update method
  const updateAuthStatus = (status) => {
    setAuthStatus(status);
  };

  return (
    <EnvironmentContext.Provider
      value={{
        environment,
        changeEnvironment,
        isLoading,
        authStatus,
        updateAuthStatus
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
};

// Custom hook to use the environment context
export const useEnvironment = () => useContext(EnvironmentContext);